/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_billing_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Fakturační příjmení`
};

const da_billing_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Fakturerings efternavn`
};

const de_billing_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Rechnungsnachname`
};

const en_billing_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Billing Last Name`
};

const es_billing_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Apellido de facturación`
};

const fr_billing_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Nom de facturation`
};

const hu_billing_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Számlázási vezetéknév`
};

const it_billing_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Cognome per la fatturazione`
};

const nl_billing_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Achternaam facturatie`
};

const pl_billing_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Nazwisko do faktury`
};

const pt_billing_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Sobrenome de faturamento`
};

const sv_billing_lastname = /** @type {(inputs: {}) => string} */ () => {
	return `Faktureringsnamn`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const billing_lastname = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.billing_lastname(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("billing_lastname", locale)
	if (locale === "cs") return cs_billing_lastname(inputs)
	if (locale === "da") return da_billing_lastname(inputs)
	if (locale === "de") return de_billing_lastname(inputs)
	if (locale === "en") return en_billing_lastname(inputs)
	if (locale === "es") return es_billing_lastname(inputs)
	if (locale === "fr") return fr_billing_lastname(inputs)
	if (locale === "hu") return hu_billing_lastname(inputs)
	if (locale === "it") return it_billing_lastname(inputs)
	if (locale === "nl") return nl_billing_lastname(inputs)
	if (locale === "pl") return pl_billing_lastname(inputs)
	if (locale === "pt") return pt_billing_lastname(inputs)
	return sv_billing_lastname(inputs)
};